import React from 'react';
import { LiliButton, LiliButtonProps, LiliButtonType } from '@lili/lili-frontend-common';
import { UserMessage } from '../LiliUserMessage/UserMessage';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../LiliCloseButton/CloseButton';

export interface NoticeModalProps {
  title: string;
  onClickOutside?: () => void;
  id: string;
  image?: React.ReactNode;
  SvgComponent?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  content: React.ReactNode;
  buttonText: string;
  secondaryButtonText?: string;
  onSubmit: () => void;
  isButtonLoading?: boolean;
  submitButtonProps?: Partial<LiliButtonProps>;
  shouldPersist?: boolean;
  shouldBlur?: boolean;
  shouldHideCloseButton?: boolean;
}

const NoticeModal = (props: NoticeModalProps) => {
  const {
    title,
    onClickOutside = () => {},
    id,
    image,
    buttonText,
    secondaryButtonText,
    onSubmit,
    isButtonLoading,
    content,
    submitButtonProps,
    SvgComponent,
    shouldPersist,
    shouldBlur,
    shouldHideCloseButton,
  } = props;
  return (
    <UserMessage onClick={onClickOutside} id={id} shouldPersist={shouldPersist} shouldBlur={shouldBlur}>
      <div className='flex flex-col rounded-[12px] bg-bw00 w-[468px] font-metricR text-bw08 px-[32px]'>
        <div className='text-center flex justify-center items-center mb-[16px] mt-[40px]'>
          {image && <div className='flex items-center h-[75px] w-[75px]'>{image}</div>}
          {SvgComponent && (
            <div className='flex items-center h-[75px] w-[75px]'>
              <SvgComponent />
            </div>
          )}
          {!shouldHideCloseButton && (
            <div className='absolute  top-3 right-2.5'>
              <CloseButton
                size={CloseButtonSize.Medium}
                id='close-modal'
                color={CloseButtonColor.Black}
                onClick={onClickOutside}
              />
            </div>
          )}
        </div>
        <div
          className='font-metricSemibold h-max-[30px] mb-1 text-gray-700 text-center leading-[30px] text-[20px] '
          id='title'
        >
          {title}
        </div>
        <div className='flex flex-col justify-between'>
          {content}

          <div className='flex justify-center gap-[14px] mb-[40px]'>
            {secondaryButtonText && (
              <LiliButton
                title={secondaryButtonText}
                id='cancel'
                onClick={onClickOutside}
                className='h-[44px]'
                type={LiliButtonType.SECONDARY}
              />
            )}
            <LiliButton
              title={buttonText}
              id='continue'
              onClick={onSubmit}
              className='h-[44px]'
              isLoading={isButtonLoading}
              {...submitButtonProps}
            />
          </div>
        </div>
      </div>
    </UserMessage>
  );
};

export default NoticeModal;
